import { render, staticRenderFns } from "./LiveStatistics.vue?vue&type=template&id=56f6d2a8&scoped=true"
import script from "./LiveStatistics.vue?vue&type=script&lang=js"
export * from "./LiveStatistics.vue?vue&type=script&lang=js"
import style0 from "./LiveStatistics.vue?vue&type=style&index=0&id=56f6d2a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f6d2a8",
  null
  
)

export default component.exports